export default __webpack_public_path__ + "static/media/edit.2fd400a3.svg";